/**
 * @generated SignedSource<<406ef081925a0236a2ddd1676d239b43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceGroupEditTabs_serviceGroup$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ServiceGroupEditMain_serviceGroup" | "ServiceGroupEditServices_serviceGroup">;
  readonly " $fragmentType": "ServiceGroupEditTabs_serviceGroup";
};
export type ServiceGroupEditTabs_serviceGroup$key = {
  readonly " $data"?: ServiceGroupEditTabs_serviceGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceGroupEditTabs_serviceGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceGroupEditTabs_serviceGroup",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServiceGroupEditMain_serviceGroup"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServiceGroupEditServices_serviceGroup"
    }
  ],
  "type": "ServiceGroup",
  "abstractKey": null
};

(node as any).hash = "03da5deeddbd2a384a5e14aaa8c6e625";

export default node;
